module.exports = __webpack_public_path__ + "img/xiaoxi.54fc14c0.png";